import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { callAjaxIO } from 'Shared/ajax_io';
import type { LeaderboardPageData, TimeFilter } from './leaderboard_types';

// The server-rendered snapshot ages from page load, not from whenever the
// cache entry is (re)created — without this, a garbage-collected entry
// reseeded from props would present stale ranks as fresh.
const pageLoadedAt = Date.now();

/**
 * One page of one time period. The server renders the initial view's page
 * into props, so only other filters and deeper pages fetch;
 * keepPreviousData leaves the old ranking visible while the next loads.
 * staleTime matches the server cache's 60s TTL.
 */
export function useLeaderboardPage(filter: TimeFilter, page: number, initial: LeaderboardPageData) {
   return useQuery({
      queryKey: ['leaderboard', filter, page],
      queryFn: () => callAjaxIO<LeaderboardPageData>('getLeaderboardPage', { filter, page }),
      initialData: filter === initial.filter && page === initial.page ? initial : undefined,
      initialDataUpdatedAt: pageLoadedAt,
      placeholderData: keepPreviousData,
      staleTime: 60_000,
   });
}
